import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// actionTypes
import { VehicleActionTypes, VehicleActions } from "../../../actionTypes/master/vehicleActionTypes";

// requests
import {
  createVehicleApi,
  editVehicleDataByIdApi,
  getVehicleDataByIdApi,
  getVehicleListApi,
} from "../../requests/master/vehicleRequests";

// actions
import {
  getVehicleList,
  setVehicleDataById,
  setVehicleList,
  setVehicleListPageCount,
} from "../../../actions/master/vehicleAction";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";

// for toast
import { toast } from "react-toastify";

function* createVehicleHandler(action: VehicleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createVehicleApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVehicleListHandler(action: VehicleActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getVehicleListApi, action.payload);

    if (data.status) {
      yield put(setVehicleList(data?.data?.rows));
      yield put(setVehicleListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVehicleDataByIdHandler(action: VehicleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getVehicleDataByIdApi, action.payload);
    if (data.status) {
      yield put(setVehicleDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editVehicleDataByIdHandler(action: VehicleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editVehicleDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getVehicleList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// vehicle sagas
export default function* vehicleSaga() {
  yield takeLatest(VehicleActions.CREATE_VEHICLE, createVehicleHandler);
  yield takeLatest(VehicleActions.GET_VEHICLE_LIST, getVehicleListHandler);
  yield takeLatest(VehicleActions.GET_VEHICLE_DATA_BY_ID, getVehicleDataByIdHandler);
  yield takeLatest(VehicleActions.EDIT_VEHICLE_DATA_BY_ID, editVehicleDataByIdHandler);
}
